import { render, staticRenderFns } from "./PermissionsDataTable.vue?vue&type=template&id=70d94c78&"
import script from "./PermissionsDataTable.vue?vue&type=script&lang=js&"
export * from "./PermissionsDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports